export enum GlobalEntities {
    clients = 'clients',
    projects = 'projects',
}
